import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store";

import LandingView from "@/views/LandingView.vue";
import HomeView from "@/views/HomeView.vue";
import AchievementsView from "@/views/AchievementsView.vue";
import LeaderboardView from "@/views/LeaderboardView.vue";
import RewardView from "@/views/RewardView.vue";
import FAQView from "@/views/FAQView.vue";

// Testing
import TestingView from "@/views/debug/TestingView.vue";

import { adminRoutes, authUser } from "@/admin/admin.js";

/*
 * All routes should be lowercase.
 */
export let routes = [
  {
    path: "/",
    name: "Landing",
    component: LandingView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    meta: {
      readEntry: true,
      readEntries: true,
      readGroups: true
    }
  },
  {
    path: "/activity",
    name: "Home",
    component: HomeView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    meta: {
      readEntry: true,
      readEntries: true,
      readGroups: true,
      readContent: true, // Read google sheet content
      isDimmed: false // This is used to determine if the badge should be dimmed
    }
  },
  {
    path: "/achievements",
    name: "Achievements",
    component: AchievementsView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    meta: {
      readEntry: true,
      readEntries: true,
      readGroups: true,
      readContent: true,
      isDimmed: true // This is used to determine if the badge should be dimmed
    }
  },
  {
    path: "/leaderboard",
    name: "Leaderboard",
    component: LeaderboardView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    meta: {
      readContent: true,
      readEntry: true,
      readEntries: true,
      readGroups: true
    }
  },
  {
    path: "/reward/:code?",
    name: "Reward",
    component: RewardView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    props: true,
    meta: {
      readContent: true,
      readEntry: true,
      isDimmed: false, // This is used to determine if the badge should be dimmed
      hideCardFooter: true // This is used to hide the card footer in the RewardView
    }
  },
  {
    path: "/faq",
    name: "FAQ",
    component: FAQView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    meta: {}
  },
  {
    path: "/testing",
    name: "Testing",
    component: TestingView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    meta: {
      readEntry: true,
      readEntries: true,
      readGroups: true,
      readContent: true
    }
  }
];

/**
 * If the application uses authentication, then add the admin routes.
 */
if (store.getters.useAuth) {
  routes = [...routes, ...adminRoutes];
}

/**
 * https://router.vuejs.org/guide/essentials/history-mode.html#hash-mode
 *
 * We use hash mode (createWebHashHistory), instead of html5 mode
 * (createWebHistory) so that it works on our S3 deployments. The html5
 * mode is more SEO-friendly, but that isn't a concern with our applications.
 */

/**
 * The 'linkExactActiveClass' is intended to style any router-view which
 * connects to the active view with the bold. It primarily will appear
 * in the `navbar`, but it will also bold any router-views, including buttons.
 */
const router = createRouter({
  mode: "history",
  linkExactActiveClass: "fw-bold",
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes
});

export default router;
